import React from "react";
import SailDate from "../../components/SailDate";
import Spinner from "../../components/common/Spinner";
import LandDate from "../../components/LandDate";

const SignForm1 = (props) => {
  if (props.currentStep !== 1) {
    return null;
  }
  return (
    <div className="SignForm1 margAll10" data-testid="SignForm1">
      {props.isLoaded && (
        <SailDate
          handleSailDateChange={props.handleSailDateChange}
          display_date_sail={props.display_date_sail}
          sailDateNowHandler={props.sailDateNowHandler}
          helpText={props.helpText}
        />
      )}
      {props.isLoaded && (
        <LandDate
          handleLandDateChange={props.handleLandDateChange}
          display_land_date={props.display_land_date}
          landDateNowHandler={props.landDateNowHandler}
          helpText={props.helpText}
        />
      )}
      {!props.isLoaded && <Spinner />}
    </div>
  );
};

export default SignForm1;
